<template>
  <div class="page-service dm-corp-page">
    <header-topbar />

    <div class="main-container">
      <section class="choose-list">
        <h3>请选择你需要的服务</h3>
        <ul>
          <li>
            <el-button type="primary" @click="gotoApply">申请试用学校智能心理服务平台</el-button>
          </li>
          <li>
            <el-button type="success" @click="gotoUnit">申请试用企业智能心理服务平台</el-button>
          </li>
          <li><el-button plain @click="gotoQuery">查询审核进度</el-button></li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import HeaderTopbar from 'components/common/HeaderTopbar'

export default {
  name: 'service',
  components: { HeaderTopbar },

  computed: {
    // 渠道归属机构code
    inviteChannelCode() {
      return this.$route.query['invite_channel_code']
    },
    // 商务code
    busCode() {
      return this.$route.query['cod']
    },
    // 模版code - 复制该渠道内容
    tplCode() {
      return this.$route.query['tplCod']
    }
  },

  methods: {
    gotoApply() {
      this.$router.push({
        name: 'trial.new.apply',
        query: {
          invite_channel_code: this.inviteChannelCode,
          cod: this.busCode,
          tplCod: this.tplCode
        }
      })
    },
    gotoUnit() {
      this.$router.push({
        name: 'trial.new.unit',
        query: {
          invite_channel_code: this.inviteChannelCode,
          cod: this.busCode,
          tplCod: this.tplCode
        }
      })
    },
    gotoQuery() {
      this.$router.push({
        name: 'trial.new.status',
        query: {
          flag: 'query',
          invite_channel_code: this.inviteChannelCode,
          cod: this.busCode,
          tplCod: this.tplCode
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-service.dm-corp-page {
  padding-bottom: 20px;
  .main-container {
    padding-top: 70px;
  }

  .choose-list {
    text-align: center;
    h3 {
      margin-bottom: 30px;
      font-size: 22px;
    }
    ul {
      text-align: center;
      li + li {
        margin-top: 20px;
      }
      .el-button {
        width: 270px;
        height: 50px;
        font-size: 16px;
      }
    }
  }
}
</style>
